export default __webpack_public_path__ + "static/BannerBlogPostsWithCharTitleAndAction-dd60441d28977d426ed07e12a495f8de.jpg";